import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside.directive';
import { OnlyAllowNumberDirective } from './only-allow-number.directive';
import { EqualHeightDirective } from './equalHeight.directive';
import { BtnTooltipHelpDirective } from './btnTooltipHelp.directive';
import { HasAccessModuleDirective } from './hasAccessModule.directive';
import { InputDomainNameDirective } from './input-domain-name.directive';
import { HasActivateModuleDirective } from './hasActivateModule.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ClickOutsideDirective,
    OnlyAllowNumberDirective,
    EqualHeightDirective,
    BtnTooltipHelpDirective,
    HasAccessModuleDirective,
    InputDomainNameDirective,
    HasActivateModuleDirective
  ],
  exports: [
    ClickOutsideDirective,
    OnlyAllowNumberDirective,
    EqualHeightDirective,
    BtnTooltipHelpDirective,
    HasAccessModuleDirective,
    InputDomainNameDirective,
    HasActivateModuleDirective
  ]
})
export class DirectivesModule { }
